import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectPayRetailerModal, selectUrlPayRetailer, setShowPayRetailer, setUrlPayRetailer } from '../../features/modals/modalsSlice';
import ModalPago from '../modals/ModalBoth';
import { Button, ContainerModal } from './PayRetailerModal';
import CloseIcon from '@mui/icons-material/Close';

const PayRetailerModal = () => {

    const dispatch = useDispatch();
    const open = useSelector(selectPayRetailerModal);
    const urlPayRetailer = useSelector(selectUrlPayRetailer);
  
    const handleClose = () => {
      dispatch(setShowPayRetailer(false));
      dispatch(setUrlPayRetailer(''));
    }
  
    return (
      <ModalPago open={open} handleClose={handleClose} maxWidth='xl' children={
        <ContainerModal>
          <Button onClick={handleClose}>
            <CloseIcon/>
          </Button>
          <iframe title='Pago Efectivo' src={urlPayRetailer} border='none' padding='5px' ></iframe>
        </ContainerModal>
      } />
    )
}

export default PayRetailerModal;